<template>
    <div v-if="show" class="kuaishou-ball" @click="handleClick">
        <img :src="imageUrl" />
        <div class="close" @click.stop="handleClose"></div> 
    </div>
</template>

<script>
import { getActivity } from '@/api';
import ScTrack from '@/utils/track'
import { isKuaishouSearch } from '@/utils/kuaishouQuery'

export default {
    name: 'KuaishouBall',
    data() {
        return {
            show: false,
            imageUrl: '',
            linkUrl: '',
            title: '',
        };
    },
    mounted() {
        this.checkChannel();
    },
    methods: {
        async checkChannel() {
            if (isKuaishouSearch(this.$route.query)) {
                await this.fetchActivity();
            }
        },
        async fetchActivity() {
            try {
                let res = await getActivity({
                    position: '9fztgw_ks_ad3',
                    activityStatus: 'NOW',
                    hiddenStatus: 'SHOWN'
                });
                

                if (res && res.list && res.list.length > 0) {
                    const activity = res.list[0];
                    this.imageUrl = activity.image;
                    this.linkUrl = activity.link;
                    this.title = activity.title || '';
                    this.show = true;

                     // 埋点-展示
                    this.$nextTick(() => {
                         ScTrack.getInstance().track('exposure_ad_show', {
                            position_id: '9fztgw_ks_ad3',
                            material_title: this.title,
                            material_url: this.linkUrl
                        })
                    })
                }
            } catch (e) {
                console.error('Fetch Kuaishou activity failed', e);
            }
        },
        handleClick() {
            // 埋点-点击
            ScTrack.getInstance().track('exposure_ad', {
                position_id: '9fztgw_ks_ad3',
                material_title: this.title,
                material_url: this.linkUrl
            })

            if (this.linkUrl) {
                window.location.href = this.linkUrl;
            }
        },
        handleClose() {
            this.show = false;
        }
    }
};
</script>

<style lang="stylus" scoped>
.kuaishou-ball {
    position: fixed;
    right: 32px;
    bottom: 95px;
    z-index: 999;
    width: 56px;
    height: 56px;
    cursor: pointer;
    // border-radius: 50%;
    // box-shadow: 0 0 0.61538462em rgba(0, 0, 0, 0.4);
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        // border-radius: 50%;
    }

    .close {
        position: absolute;
        top: -16px;
        right: -16px;
        width: 16px;
        height: 16px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        
        &::before, &::after {
            content: "";
            position: absolute;
            width: 10px;
            height: 1px;
            background: #fff;
            transform: rotate(45deg);
        }
        &::after {
            transform: rotate(-45deg);
        }
    }
}
</style>
